export const KeybackupSettingsTestIds = {
  containerInfo: 'container_info',
  textTitle: 'text_title',
  textDescription: 'text_description',
  containerKeysection: 'container_keysection',
  containerKeyrow: 'container_keyrow',
  dialogSuggestion: 'dialog_suggestion',
  containerSuggestionheader: 'container_suggestionheader',
  textSuggestiontitle: 'text_suggestiontitle',
  textSuggestionsubtitle: 'text_suggestionsubtitle',
  fieldSuggestion: 'field_suggestion',
  fieldSuggestionInput: 'field_suggestion_input',
  buttonCopy: 'button_copy',
  containerErrors: 'container_errors',
  textError: 'text_error',
  containerSuggestionbuttons: 'container_suggestionbuttons',
  buttonResetpassword: 'button_resetpassword',
  verifyKeybackup: 'verify_keybackup',
  buttonConfirmResetKey: 'button_confirm_reset_key',
  buttonConfirm: 'button_confirm',
  buttonConfirmFinal: 'button_confirm_final',
  buttonCancelFinal: 'button_cancel_final',
  buttonConfirmVerification: 'button_confirm_verification',
  buttonCancelResetKey: 'button_cancel_reset_key',
  buttonConfirmPermission: 'button_confirm_permission',
  resetInput: 'dialog_reset_input',
  permissionResetDialog: 'dialog_permission_content',
  dialogFinalContent: 'dialog_final_content',
  spinnerBackdrop: 'spinner_backdrop'
} as const;
